import React, { useState } from "react";
import "./index.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";

//IMAGES
import editIcon2 from "../../img/icon-edit2.png";
import locationIcon2 from "../../img/location-icon3.png";
import languageIcon from "../../img/icon-help-language.png";
import referIcon from "../../img/icon-refer.png";
import helpIcon from "../../img/icon-help.png";
import wholesaleIcon from "../../img/icon-boxes.png";
import newStickerIcon from "../../img/icon-new-sticker.png";
import phoneIcon from "../../img/icon-calling.gif";
import closeIcon from "../../img/Close_round.png";
import thankyouIcon from "../../img/icon-tick.gif";
import backIcon from "../../img/Arrow.png";
import MenuBar from "../../User/MenuBar";
import Signin from "../../User/SignIn";
import ChangeLanguage from "./Components/ChangeLanguage";
import EditDetail from "./Components/EditDetails";
import CustomerCare from "./Components/CustomerCare";
import MyOrder from "./Components/MyOrder";
import SignOut from "./Components/SignOut";
const UserAccount = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showLanguage, setShowLanguage] = useState(false);
  const [showEditDetails, setShowEditDetails] = useState(false);
  const [showHelp, setShowHelp] = useState(false);
  const [showSignOut, setShowSignOut] = useState(false);

  const user = useSelector((state) => state?.user?.info);

  return (
    <>
      {user ? (
        <>
          {/* TITLE BAR */}
          <div className="T1">
            <div className="d-flex align-items-center justify-content-between T2">
              <div>
                <div className="T3">{user?.name}</div>
                <div className="T4">+91 - {user?.phn}</div>
              </div>
              <div
                className="ms-auto d-flex align-items-center T5"
                onClick={() => setShowEditDetails(true)}
                data-bs-toggle="offcanvas"
                data-bs-target="#editInfo"
              >
                <img src={editIcon2} alt="edit" width={16} className="T6" />
                Edit
              </div>
            </div>
          </div>
          {/* ACCOUNT SETTINGS */}
          <div className="account-list">
            {/* ---------------------------MANANGE ADDRESS------------------------ */}
            <div
              className="account-list-item"
              onClick={() => {
                navigate("/account/manage-address");
              }}
            >
              <img src={locationIcon2} alt="edit" width={24} className="T6 account-list-icon" />
              <div>
                <h4>Manage Address</h4>
                <p>Add new, edit or delete your address</p>
              </div>
              <span className="bi bi-chevron-right ms-auto my-auto"></span>
            </div>
            {/* Wholesale Poduct */}
            <div className="account-list-item">
              <img src={wholesaleIcon} alt="edit" width={24} className="account-list-icon" />
              <div>
                <h4 className="m-0">
                  Wholesale Poduct{" "}
                  <img
                    src={newStickerIcon}
                    alt="edit"
                    className="ms-1"
                    width={24}
                  />
                </h4>
                <p>Buy product in the bulk now</p>
              </div>
              <span className="bi bi-chevron-right ms-auto my-auto"></span>
            </div>

            {/* Wholesale Page Start */}
            <div className="wholesale-wrapper" style={{ display: "none" }}>
              <div className="ma2 fixed-top d-flex align-items-center transition text-orange bg-white ">
                <div className="text-center my-auto ma3">
                  <img
                    src={backIcon}
                    alt=""
                    width={24}
                    onClick={() => navigate(-1)}
                    className="account-list-icon"
                  />
                </div>
                <div className="w-100 my-auto overflow-hidden">
                  <h2 className="ma4">Manage Address</h2>
                </div>
              </div>
              <div className="wholesale-mode">
                <div className="img-thumbnail">
                  <img src={wholesaleIcon} alt="edit" width={24} />
                </div>
                <h4>Wholesale mode</h4>
              </div>
              <h6>
                Buy the products in bulk or set of pack usually at a discount
                rate.
              </h6>
              <h3>Enter your GSTIN</h3>
              <div className="form-floating">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter GST"
                  id="GSTInput"
                />
                <label htmlFor="GSTInput">Enter GST here</label>
              </div>
              <div className="needhelp-card">
                <img src={phoneIcon} alt="edit" width={48} />
                <div>
                  <h4>Need help Call us now?</h4>
                  <p>Our Team will call you shortly for help!</p>
                </div>
                <button
                  className="btn btn-green"
                  data-bs-toggle="modal"
                  data-bs-target="#thankYouModal"
                >
                  Call now
                </button>
              </div>
              <div className="cart-bottom-sheet bg-white">
                <button
                  className="btn btn-orange morebtn m-0 w-100"
                  data-bs-toggle="modal"
                  data-bs-target="#gstModal"
                >
                  Continue
                </button>
              </div>

              {/************************** Modal - Wholesale ********************************/}
              <div
                className="modal fade custom-modal thankYouModal wholesaleModal"
                id="gstModal"
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog  modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <img
                          src={closeIcon}
                          alt=""
                          width={24}
                          className="d-block m-auto"
                        />
                      </button>
                      <img
                        src={thankyouIcon}
                        alt=""
                        width={150}
                        className="d-block m-auto"
                      />
                      <h4 className="mb-0">
                        Wholesale product is now available with tag!
                      </h4>
                      <div className="badge">
                        <img src={wholesaleIcon} alt="edit" width={24} />
                        Wholesale
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/********** **************** Modal - Wholesale End ********************************/}

              {/************************** Thank You Modal Start ********************************/}
              <div
                className="modal fade custom-modal thankYouModal"
                id="thankYouModal"
                tabIndex="-1"
                aria-labelledby="thankYouTitel"
                aria-hidden="true"
              >
                <div className="modal-dialog  modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-body p-0">
                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      >
                        <img
                          src={closeIcon}
                          alt=""
                          width={24}
                          className="d-block m-auto"
                        />
                      </button>
                      <img
                        src={thankyouIcon}
                        alt=""
                        width={150}
                        className="d-block m-auto"
                      />
                      <h5 className="modal-title mb-0" id="thankYouTitel">
                        Thank you for contacting us!
                      </h5>
                      <p className="m-0 text-center">
                        Our Team will call you soon
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/************************** Modal End ********************************/}
            </div>
            {/* Wholsale Page End */}

            {/* Change Language */}
            <div
              className="account-list-item"
              onClick={() => setShowLanguage(true)}
            >
              <img src={languageIcon} alt="edit" width={24} className="account-list-icon" />
              <div>
                <h4>Change language</h4>
                <p>English and हिन्दी</p>
              </div>
              <span className="bi bi-chevron-right ms-auto my-auto"></span>
            </div>
            {/* Refer & Earn */}
            {/* <a
              style={{ textDecoration: "none" }}
              className="account-list-item"
              href="whatsapp://send?text=Hey! I'm having a wonderful experience with GoWholsale and it has all the sellers near me. You can also try GoWholsale and grow your business seller.gowholsale.com"
            >
              <img
                src={referIcon}
                alt="edit"
                width={24}
              />
              <div>
                <h4>Refer & Earn</h4>
                <p>Refer rashanpoint to your friend</p>
              </div>
              <i className="bi bi-chevron-right ms-auto my-auto"></i>
            </a> */}

            {/* Help */}
            <div
              className="account-list-item"
              onClick={() => setShowHelp(true)}
            >
              <img src={helpIcon} alt="edit" width={24} className="account-list-icon" />
              <div>
                <h4>Help</h4>
                <p>Customer care service for you</p>
              </div>
              <span className="bi bi-chevron-right ms-auto my-auto"></span>
            </div>
            {/* MY ORDERS------------------------------------- */}
            <MyOrder />
            {/* About us */}
            <div
              className="account-list-item"
              onClick={() => navigate("/aboutUs")}
            >
              <div>
                <h4 style={{ margin: "10px 0" }}>About us</h4>
              </div>
              <i className="bi bi-chevron-right ms-auto my-auto"></i>
            </div>

            {/* Tnc */}
            <div
              className="account-list-item"
              onClick={() => navigate("/termsCondition")}
            >
              <div>
                <h4 style={{ margin: "10px 0" }}>Terms & Conditions</h4>
              </div>
              <i className="bi bi-chevron-right ms-auto my-auto"></i>
            </div>

            {/* Privacy-policy */}
            <div
              className="account-list-item"
              onClick={() => navigate("/privacyPolicy")}
            >
              <div>
                <h4 style={{ margin: "10px 0" }}>Privacy & Policy</h4>
              </div>
              <i className="bi bi-chevron-right ms-auto my-auto"></i>
            </div>
            {/* Sign-Out */}
            <div
              className="account-list-item"
              onClick={() => setShowSignOut(true)}
            >
              <div>
                <h4 style={{ margin: "10px 0" }}>Sign Out</h4>
              </div>
              <i className="bi bi-chevron-right ms-auto my-auto"></i>
            </div>
            <div style={{ marginTop: "55px" }} />
            {/* ------------------------------------------------------------------------- */}
          </div>

          {/* BOTTOM SHEETS */}
          <ChangeLanguage
            showLanguage={showLanguage}
            setShowLanguage={setShowLanguage}
          />
          <EditDetail
            showEditDetails={showEditDetails}
            setShowEditDetails={setShowEditDetails}
          />
          <CustomerCare showHelp={showHelp} setShowHelp={setShowHelp} />
          <SignOut showSignOut={showSignOut} setShowSignOut={setShowSignOut} />
        </>
      ) : (
        <Signin />
      )}

      <MenuBar active="Account" />
    </>
  );
};

export default UserAccount;
